import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import myConnections from "../../utility/connect";
const sliceName = "citySlice";

const initialState = {
  cities: [],
};

let getCities = async (_, thunkAPI) => {
  const response = await myConnections.get({
    path: "sifrarnici/get_cities",
    data: {},
    headers: {},
    thunkAPI: thunkAPI,
  });

  return response;
};

getCities = createAsyncThunk(`${sliceName}/getCities`, getCities);
getCities.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, action) => {
    state.cities = action.payload.items;
  },
  rejected: (state, action) => {
  },
};

const countriesSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(getCities.pending, getCities.myLC.pending);
    builder.addCase(getCities.fulfilled, getCities.myLC.fulfilled);
    builder.addCase(getCities.rejected, getCities.myLC.rejected);
  },
});

export const asyncActions = { getCities };
export const actions = countriesSlice.actions;
export default countriesSlice.reducer;
